import React, { Component, Fragment, PureComponent } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import Keyboard from '../keyboard/keyboardInput';
import { get } from 'lodash';

@inject('lineStore', 'dictStore', 'accountStore')
@observer
export default class OneClick extends Component {

  handleChange = (e) => {
    this.props.lineStore.basket.newSetIsBetOneClickSum(e);
    this.props.lineStore.basket.newSetIsBetOneClick(true)
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.lineStore.basket.applyOneClickAmount();
  }

  render() {
    const basketData = this.props.lineStore.basket.basketData;
    const oneClickBetAmount = get(basketData, 'oneClickBetAmount')
    const isBetRequestLoading = get(basketData, 'isBetRequestLoading')
    const { isLocked } = this.props.lineStore.basket;
    const { getLang } = this.props.dictStore;
    const { basketPosition } = this.props.accountStore.accountSettings;
    return (
      <div className="basket-row">
        <div className="basket-one-click clearfix">
          <form onSubmit={this.handleSubmit}>
            <div className="fl_l basket-one-click__amount">
              <Keyboard
                className="form-control"
                value={String(oneClickBetAmount)}
                type="text"
                maxLength="6"
                onChange={this.handleChange}
                autoComplete="off"
                positionX={basketPosition == "left" ? 'right' : 'left'}
                positionY="bottom"
              />
            </div>
            <div className="fl_r">
              <button disabled={isBetRequestLoading} className={`flat_button basket-one-click__button ${isBetRequestLoading ? 'wait' : ''}`} >{getLang('APPLY')}</button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/basket/oneClick.js